import styles from './styles/BackGround.module.scss';
import { inject, observer } from 'mobx-react';
import { factorMapStr, factorMapEnStr } from '@/utils/contants/caseSimulation';
import withRouter from '@/components/withRouter';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import useBackGround from '@/pages/hooks/CaseSImulation/useBackGround';
const BackGround = (props) => {
    const { sectionsObj, onStart, onClickCard } = useBackGround(props);
    let { simulation } = props.store;
    let { background = {}, caseInfo } = simulation;
    let { sections = [] } = background;
    return (
        <div className={styles.container}>
            {/* 主标题 */}
            <div className={styles.title}>【{caseInfo?.case_title}】</div>
            <div className={styles.backgroundWrap}>
                <div className={styles.line}>
                    <div data-left={true} className={styles.lineItem}></div>
                    <div data-center={true} className={styles.lineItem}>
                        <div className={styles.lineTitle}>{sectionsObj?.[1]?.title}</div>
                        <div className={styles.lineFactor}>{factorMapStr?.[1]}</div>
                    </div>
                    <div data-center={true} className={styles.lineItem}>
                        <div className={styles.lineTitle}>{sectionsObj?.[2]?.title}</div>
                        <div className={styles.lineFactor}>{factorMapStr?.[2]}</div>
                    </div>
                    <div data-right={true} className={styles.lineItem}></div>
                </div>
                <div className={styles.line}>
                    <div data-left={true} className={styles.lineItem}></div>
                    <div data-center={true} className={styles.lineItem}>
                        <div className={styles.lineTitle}>{sectionsObj?.[3]?.title}</div>
                        <div className={styles.lineFactor}>{factorMapStr?.[3]}</div>
                    </div>
                    <div data-right={true} className={styles.lineItem}></div>
                </div>
                <div className={styles.line}>
                    <div data-left={true} className={styles.lineItem}></div>
                    <div data-center={true} className={styles.lineItem}>
                        <div className={styles.lineTitle}>{sectionsObj?.[4]?.title}</div>
                        <div className={styles.lineFactor}>{factorMapStr?.[4]}</div>
                    </div>
                    <div data-center={true} className={styles.lineItem}>
                        <div className={styles.lineTitle}>{sectionsObj?.[5]?.title}</div>
                        <div className={styles.lineFactor}>{factorMapStr?.[5]}</div>
                    </div>
                    <div data-right={true} className={styles.lineItem}></div>
                </div>
            </div>

            {/* 开始按钮 */}

            <div onClick={onStart} className={`${styles.button}`}>
                <Space>
                    <span> 现在开始</span>
                    <ArrowRightOutlined />
                </Space>
            </div>
        </div>
    );
};
export default withRouter(inject('store')(observer(BackGround)), 'background');
